import styled from "styled-components";

const FormWrapper = styled.div`
  color: #333;
  border-radius: 4px;
  padding: 20px;
  height: fit-content;
  font-family: Raleway;

  #candidate-page-select {
    padding: 1px;
    position: absolute;
    left: 10px;
    top: 15px;
    width: 200px;

    &:focus {
      border-color: #f2008c;
      outline: none;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }

  #candidate-page-form-textarea {
    border: 2px solid #e7e7e7;
    border-radius: 4px;
    width: 100%;
    height: 3em;
    resize: none;
    padding: 10px;
    position: absolute;
    left: 10px;
    bottom: 10px;
    width: 520px;

    &:focus {
      border-color: #f2008c;
      outline: none;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }

  #candidate-page-file-input {
    width: 230px;
    position: absolute;
    right: 0;
    top: 10px;
    border-radius: 4px;
    background-color: #fff;

    &:focus {
      border-color: #f2008c;
      outline: none;
      -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(233, 102, 163, 0.6);
    }
  }

  #candidate-page-submit-button {
    font-weight: bold;
    color: #fff;
    background: #f2008c;
    border: 1px solid #f2008c;
    box-sizing: border-box;
    border-radius: 4px;
    line-height: 22px;
    color: #fff;
    padding: 12px 12px;
    font-family: Raleway;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: capitalize;
    font-size: 1em;
    min-width: 100px;
    cursor: pointer;
    outline: none;
    position: absolute;
    right: 10px;
    bottom: 10px;
    transition: 0.15s ease-in-out;

    &:hover {
      color: #fff;
      background: #bc006d;
      border: 1px solid #f2008c;
    }

    &:focus {
      background: #673490;
      border: 1px solid #673490;
    }
  }

  #date-input {
    position: absolute;
    right: 255px;
    top: 15px;
    padding: 2px 5px;
  }

  #date-input-hint-icon {
    position: absolute;
    top: 20px;
    right: 235px;
    z-index: 1;
  }
`;

export { FormWrapper as default };
